<footer class="footer pharmacy-footer">
    <div class="container">
        <div class="mid-footer">
            <div class="row">
                <div class="col-xl-2 col-lg-3 col-md-4">
                    <div class="footer-links">
                        <h4>Company</h4>
                        <ul class="pages-links">
                            <li><a [routerLink] = "routes.aboutUs">About Doccure</a></li>
                            <li><a href="javascript:void(0);">Customers Speak</a></li>
                            <li><a href="javascript:void(0);">In the News</a></li>
                            <li><a href="javascript:void(0);">Career</a></li>
                            <li><a [routerLink] = "routes.contactUs">Contact</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4">
                    <div class="footer-links">
                        <h4>Shopping</h4>
                        <ul class="pages-links">
                            <li><a href="javascript:void(0);">Browse by A-Z</a></li>
                            <li><a href="javascript:void(0);">Browse by Manufacturers</a></li>
                            <li><a href="javascript:void(0);">Health Articles</a></li>
                            <li><a href="javascript:void(0);">Offers / Coupons</a></li>
                            <li><a [routerLink] = "routes.faq">FAQs</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4">
                    <div class="footer-links">
                        <h4>Our Policies</h4>
                        <ul class="pages-links">
                            <li><a [routerLink] = "routes.termsCondition">Terms and Conditions</a></li>
                            <li><a [routerLink] = "routes.privacyPolicy">Privacy Policy</a></li>
                            <li><a href="javascript:void(0);">Fees and Payments</a></li>
                            <li><a href="javascript:void(0);">Shipping and Delivery</a></li>
                            <li><a href="javascript:void(0);">Return, Refund </a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4">
                    <div class="footer-links">
                        <h4>Our Services</h4>
                        <ul class="pages-links">
                            <li><a href="javascript:void(0);">Order Medicines</a></li>
                            <li><a href="javascript:void(0);">Book Lab Tests</a></li>
                            <li><a href="javascript:void(0);">Consult a Doctor</a></li>
                            <li><a href="javascript:void(0);">Ayurveda Articles</a></li>
                            <li><a href="javascript:void(0);">Careers</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-8">
                    <div class="footer-links">
                        <h4>Subscribe to Newsletter</h4>
                        <form action="#">
                            <div class="input-block">
                                <input type="email" class="form-control" placeholder="Enter Email Address">
                                <button type="submit" class="submit-btn">Submit</button>
                            </div>
                        </form>
                        <div class="app-store-links">
                            <a href="javascript:void(0);"><img src="assets/img/icons/app-store.svg" alt="Img"></a>
                            <a href="javascript:void(0);"><img src="assets/img/icons/google-play.svg" alt="Img"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
        <div class="copy-right text-center">
            <p>Copyright © 2024 Bi-newvision. All Rights Reserved</p>
        </div>
    </div>
</footer>
